import React from 'react';
import { ArrowRight, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AboutMe() {
    
    return (
        <section id="sobre-mi" className="py-24">
            <div className="max-w-5xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    {/* Header */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold text-green-400 mb-6">
                            Mi Historia
                        </h2>
                        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                            La prueba de que es posible: mi transformación real
                        </p>
                        <div className="w-20 h-1 bg-green-500 mx-auto mt-6"></div>
                    </div>

                    {/* Timeline comparison */}
                    <div className="bg-black/40 p-10 rounded-2xl border border-green-500/20 mb-12">
                        <div className="max-w-3xl mx-auto">
                            <div className="grid md:grid-cols-2 gap-8 text-center">
                                <div className="space-y-2">
                                    <p className="text-5xl font-bold text-gray-500">2020</p>
                                    <p className="text-xl font-semibold text-gray-300">Técnico Radiólogo</p>
                                    <p className="text-gray-400">Viviendo con mis padres</p>
                                    <p className="text-gray-400">Sin reconocimiento económico</p>
                                    <p className="text-gray-400">Levantándome temprano sin poder trabajar desde casa</p>
                                </div>
                                <div className="space-y-2">
                                    <p className="text-5xl font-bold text-green-400">2022</p>
                                    <p className="text-xl font-semibold text-gray-100">Ingeniero de Datos</p>
                                    <p className="text-gray-300">Poder alquilar mi propio departamento</p>
                                    <p className="text-gray-300">Vacaciones con mi hijo y mi familia</p>
                                    <p className="text-gray-300">Con capacidad de ahorro</p>
                                    <p className="text-gray-300">Darle una vida digna a mi familia</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Photos comparison */}
                    <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12">
                        <div className="text-center">
                            <div className="w-64 h-64 mx-auto mb-4 rounded-2xl overflow-hidden shadow-xl border border-green-500/20 bg-black/40">
                                <img src="/images/Tec_radiologo_gago.jpg" alt="Técnico Radiólogo" className="w-full h-full object-cover" />
                            </div>
                            <p className="text-xl font-bold text-gray-200">Técnico Radiólogo</p>
                            <p className="text-base text-gray-400 font-medium">2020</p>
                        </div>
                        <div className="text-gray-500">
                            <ArrowRight className="w-16 h-16 md:w-20 md:h-20 transform md:rotate-0 rotate-90" />
                        </div>
                        <div className="text-center">
                            <div className="w-64 h-64 mx-auto mb-4 rounded-2xl overflow-hidden shadow-xl border border-green-500/20 bg-black/40">
                                <img src="/images/Data_engineer_Meli.jpg" alt="Data Engineer" className="w-full h-full object-cover" />
                            </div>
                            <p className="text-xl font-bold text-gray-100">Data Engineer</p>
                            <p className="text-base text-gray-300 font-medium">Mercado Libre 2022</p>
                        </div>
                    </div>

                    {/* Compact bio strip */}
                    <div className="bg-black/50 rounded-2xl p-6 md:p-8 border border-green-500/20 mb-12">
                        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
                            <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-green-500/30 flex-shrink-0">
                                <img src="/images/Yo.jpeg" alt="Luciano Argolo" className="w-full h-full object-cover" />
                            </div>
                            <div className="flex-1 text-center md:text-left">
                                <h3 className="text-xl font-bold text-gray-100">Luciano Argolo</h3>
                                <p className="text-gray-400 text-sm">Sr Data Engineer · Buenos Aires</p>
                                <p className="text-gray-300 mt-2 leading-relaxed">
                                    Me echaron como radiólogo en pandemia. En 10 meses conseguí mi primer trabajo en Data.
                                    Hoy, 5 años después, <strong className="text-white">me dedico a cambiar la vida de otras personas</strong>.
                                </p>
                            </div>
                            <div className="flex flex-col items-center gap-4 flex-shrink-0">
                                <div className="flex gap-4">
                                    <div className="text-center px-4 py-2 bg-gray-900/60 rounded-xl border border-green-500/20">
                                        <div className="text-lg font-bold text-green-400">5+</div>
                                        <div className="text-[10px] text-gray-400">Años en Data</div>
                                    </div>
                                    <div className="text-center px-4 py-2 bg-gray-900/60 rounded-xl border border-green-500/20">
                                        <div className="text-lg font-bold text-green-400">+40</div>
                                        <div className="text-[10px] text-gray-400">Mentoreados 1:1</div>
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <a href="https://www.linkedin.com/in/luciano-argolo/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                                        <Linkedin className="w-3.5 h-3.5 text-white" />
                                    </a>
                                    <a href="https://www.youtube.com/@lucianoargolo1608" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                                        <span className="text-white font-bold text-[10px]">YT</span>
                                    </a>
                                    <a href="https://www.tiktok.com/@lucianoargolo0" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-slate-700 hover:bg-slate-800 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                                        <span className="text-white font-bold text-[10px]">TT</span>
                                    </a>
                                    <a href="https://www.instagram.com/lucianoargolo22/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                                        <span className="text-white font-bold text-[10px]">IG</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </motion.div>
            </div>
        </section>
    );
}
